export class CourseItem {
    id?: number;
    name: string;
    type: string;
    school_year: number;
    start_date: string;
    end_date: string;
    description: string;
    status: string;

    constructor() {
        this.name = "";
        this.type = "";
        this.description = "";
    }
}

export class CourseList {
    count: number;
    data: ListCourseItem[];

    constructor () {
        this.count = 0;
        this.data = [];
    }
}

export class ListCourseItem {
    id: number;
    name: string;
    type: string;
    school_year: number;
    start_date: string;
    end_date: string;
    description: string;
    status: string;
    hol_classes: any[];
    total_class: number
}

export class CourseClassItem {
    id?: number;
    thumbnail_id?: string;
    name: string;
    room: string;
    teacher: string;
    max_number: number;
    total_cost: number;
    activities: string;
    suitable_from: string;
    suitable_to: string;
    status: string;
    campus_id: number;
    hol_course_id: string[];
    cost_per_week?: number;
    prices?: any[];

    constructor() {
        this.name = "";
        this.room = "";
        this.teacher = "";
        this.activities = "";
        this.suitable_from = "";
        this.suitable_to = "";
        this.status = "";
        this.total_cost = 0;
        this.prices = [];
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/Course.ts